module.exports = __webpack_public_path__ + "static/media/heavyRain.48967d75.ico";